import React from 'react';
import '../styles/about.css';

const MILESTONES = [
  {
    id: 'journey-1',
    year: '2024',
    text: 'CoreVision established in Singapore.',
  },
  {
    id: 'journey-2',
    year: '2024',
    text: 'NMS platform obtained NEA approval for real-time noise monitoring.',
  },
  {
    id: 'journey-3',
    year: '2024',
    text: 'Expanded monitoring solution capability for noise, vibration, and IoT sensor integration.',
  },
  {
    id: 'journey-4',
    year: '2026',
    text: 'IDMS platform introduced for instrumentation data management, reporting, and multi-sensor monitoring.',
  },
  {
    id: 'journey-5',
    year: '2026',
    text: 'Continued development of integrated monitoring solutions for construction, infrastructure, and environmental compliance projects.',
  },
];

const VALUES = [
  {
    icon: 'ENG',
    title: 'Engineering Reliability',
    desc: 'Built with strong engineering principles to ensure stable, accurate, and dependable monitoring performance in real-world site conditions.',
  },
  {
    icon: 'DATA',
    title: 'Real-Time Monitoring',
    desc: 'Cloud-connected systems delivering continuous data for noise, vibration, and instrumentation monitoring with timely alerts.',
  },
  {
    icon: 'CARE',
    title: 'Practical Project Support',
    desc: 'Supporting contractors and consultants with deployment, data handling, reporting, and ongoing system support.',
  },
];

const About: React.FC = () => {
  return (
    <section id="about" className="cv-about">
      <div className="cv-container">
        <div className="cv-section-header">
          <span className="cv-section-tag">Who We Are</span>
          <h2 className="cv-section-title">Technology-Driven Monitoring for Infrastructure Projects</h2>
          <p className="cv-section-subtitle">
            CoreVision is a Singapore-based engineering company specialising in construction
            monitoring, instrumentation, and IoT data systems for civil engineering, infrastructure,
            and environmental compliance.
          </p>
        </div>

        <div className="cv-about__grid">
          <div className="cv-about__story">
            <h3>Our Story</h3>
            <p>
              CoreVision was established in 2024 as a technology-driven monitoring solutions
              company focused on real-time noise, vibration, and instrumentation data management
              systems.
            </p>
            <p>
              Although CoreVision is a new company, our team brings strong engineering experience
              in construction monitoring, sensor integration, IoT data acquisition, and
              regulatory-compliant reporting for infrastructure and building projects.
            </p>
            <p>
              Our solutions are designed to support contractors, consultants, and
              government-related projects with reliable monitoring hardware, cloud-connected data
              systems, automated reporting, and responsive technical support.
            </p>
          </div>

          <div className="cv-about__milestones">
            <h3>Our Journey</h3>
            <div className="cv-timeline">
              {MILESTONES.map((m) => (
                <div className="cv-timeline__item" key={m.id}>
                  <div className="cv-timeline__year">{m.year}</div>
                  <div className="cv-timeline__body">
                    <p>{m.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="cv-about__values">
          {VALUES.map((v) => (
            <div className="cv-about__value-card" key={v.title}>
              <span className="cv-about__value-icon">{v.icon}</span>
              <h4>{v.title}</h4>
              <p>{v.desc}</p>
            </div>
          ))}
        </div>

        <div className="cv-about__clients">
          <p className="cv-about__clients-label">Trusted by Singapore's leading agencies</p>
          <div className="cv-about__clients-list">
            {['NEA'].map((c) => (
              <span className="cv-about__client-badge" key={c}>{c}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
